module.exports = __webpack_public_path__ + "static/media/openday.a3f640a4.jpg";